// extracted by mini-css-extract-plugin
export var actionIcon = "_os-0";